import { type InsightsTargetingSpecJson } from "../../gql-generated/insights-types";

export const emptyTargetingSpec: InsightsTargetingSpecJson = {
    devices: [],
    demographics: [],
    geos: [],
};
